import { render, staticRenderFns } from "./TemplateInputs.vue?vue&type=template&id=7479a87c&"
import script from "./TemplateInputs.vue?vue&type=script&lang=ts&"
export * from "./TemplateInputs.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports